import AppStore from '../logic/store/AppStore';

export function getCurrency() {
  const state = AppStore.getState();
  return state.auth.profile.currency;
}

export function getCurrencySymbol(currency = null) {
  if(!currency) {
    currency = getCurrency();
  }

  const map = {
    'EUR': '€',
    'USD': '$',
    'AUD': '$',
    'GBP': '£',
    'GIP': '£',
  };

  return map[currency] || currency;
}

export default {
  getCurrency,
  getCurrencySymbol
}
